import psHttp from '@patsnap/common-ps-http';
import { coreSearchApiUrlPrefix } from '../../config/constants';

export function getStatusApi() {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/data-coverage/status`,
        headers: {
            'X-API-Version': '2.0'
        },
        method: 'GET',
        cache: true,
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getNplDataSourceApi() {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/data-coverage/paper-status`,
        headers: {
            'X-API-Version': '2.0'
        },
        method: 'GET',
        cache: true,
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getLegalDataSourceApi() {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/data-coverage/legal`,
        method: 'GET',
        headers: {
            'X-API-Version': '2.0'
        },
        cache: true,
        transformCode: true
    }).then(({
        data
    }) => {
        return data.data || {};
    });
}

export function getLitigationInitApi() {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/data-coverage/litigation`,
        method: 'GET',
        headers: {
            'X-API-Version': '2.0'
        },
        transformCode: true,
        cache: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getOverviewInfo() {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/data-coverage/getOverviewInfo`,
        method: 'GET',
        headers: {
            'X-API-Version': '2.0'
        },
        transformCode: true,
        cache: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function featureDataList() {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/data-coverage/featureDataByLang`,
        method: 'GET',
        headers: {
            'X-API-Version': '2.0'
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function featureDataItemById(id) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/data-coverage/featureDataById?featureDataId=${id}`,
        method: 'GET',
        headers: {
            'X-API-Version': '2.0'
        },
        transformCode: true,
    }).then(({ data }) => {
        return { ...data.data, id } || {};
    });
}

/**
 * 获取9个国家详情数据
 */
export function fetchDataByCountry(params) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/data-coverage/nineCountryUpdates`,
        method: 'GET',
        params,
        headers: {
            'X-API-Version': '2.0'
        },
        transformCode: true,
        cache: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function fetchPatentWeekData(params) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/data-coverage/update-week-patent-data`,
        method: 'GET',
        params,
        headers: {
            'X-API-Version': '2.0'
        },
        cache: true,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}
